import React, { useState, useEffect } from 'react';
import { confirmResetPassword, resetPassword, signOut } from 'aws-amplify/auth';
import { Form, Button, Spinner } from 'react-bootstrap';
import { useNavigate, useLocation } from "react-router-dom";


import toastr from "toastr";

function ChangePassword() {
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);


  const navigate = useNavigate();
  const location = useLocation();

  const [state] = useState(location.state || {});

  useEffect(() => {
    document.body.className = 'login';
  }, []);

  const gotoSuccess = (e) => {
    navigate('/confirmchangepassword');
  }

  async function handleConfirmResetPassword(e) {
    e.preventDefault();
    setLoading(true);
    try {
      if (Object.keys(state).length === 1 && Object.keys(state) == 'email') {
        if (code === '' || password === '') {
          setLoading(false);
          toastr.warning('Preencha os campos obrigatórios');
          return;
        } else {
          if (confirmPassword.toString() !== password.toString()) {
            setLoading(false);
            toastr.warning('A confirmação de senha é diferente da senha inserida');
            return;
          } else {
            await confirmResetPassword({ username: state.email, confirmationCode: code, newPassword: password });
            gotoSuccess();
          }
        }
      } else {
        toastr.warning('A solicitação não é mais válida, tente novamente');
        setTimeout(() => {
          navigate('/forgotpassword');
        }, 2000);
      }

    } catch (error) {
      setLoading(false);
      console.log(error);
      if (error.name === 'ExpiredCodeException') {
        toastr.error('Esse código de vilidação expirou, clique em reenviar código e tente novamente')
      } else if (error.name === 'CodeMismatchException'){
        toastr.error('O código inserido não é válido');
      } else {
        if (error.name === 'UserNotFoundException') {
          toastr.error('O usuário não existe');
        } else if (error.name === 'InvalidPasswordException') {
          toastr.error('A senha não atende aos requisitos da política de senha');
        } else {
          if (error.name === 'LimitExceededException') {
            toastr.error('Limite de tentativas excedida, tente novamente mais tarde');
          } else {
            if (error.name === 'NotAuthorizedException') {
              toastr.error('Ocorreu um erro ao solicitar alteraçõa de senha, senha atual fornecida é incorreta');
            } else {
              toastr.error('Ocorreu um erro ao solicitar a alteração de senha');
            }
          }
        }
      }
      return;
    }
  }

  const handleResendCode = async (e) => {
    setLoading(true);
    try {
      const output = await resetPassword({ username: state.email });
      toastr.success(`Um código de confirmação foi enviado para ${state.email}`);
      setLoading(false);
    } catch (error) {
      toastr.error('Erro ao reenviar o código de verificação');
      setLoading(false);
    }
  }

  const handleCodeChange = (e) => {
    setCode(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };


  return (
    <div className='panel-login' style={{ height: "auto", paddingBottom: "25px", paddingTop: "25px" }}>
      <img src={process.env.PUBLIC_URL + '/static/imagens/logo.svg'} className='display--block margin--auto' alt='Logomarca' />
      <h1 className='title-login text-center' style={{ marginTop: "15px" }}>Insira a nova senha e confirme</h1>
      <Form onSubmit={handleConfirmResetPassword}>
        <Form.Group controlId="formBasicCode" className='group-input--big' style={{ marginTop: "15px" }}>
          <Form.Label>Código enviado por e-mail:*: </Form.Label>
          <Form.Control type="text" value={code} onChange={handleCodeChange} className='input--big' />
          <a href='javascript:;' onClick={handleResendCode}>Reenviar código</a>
        </Form.Group>

        <Form.Group controlId="formBasicPassword" className='group-input--big' style={{ marginTop: "15px" }}>
          <Form.Label>Senha*:</Form.Label>
          <Form.Control type="password" value={password} onChange={handlePasswordChange} className='input--big' />
        </Form.Group>

        <Form.Group controlId="formBasicConfirmPassword" className='group-input--big' style={{ marginTop: "15px", marginBottom: "15px" }}>
          <Form.Label>Confirmar Senha*:</Form.Label>
          <Form.Control type="password" value={confirmPassword} onChange={handleConfirmPasswordChange} className='input--big' />
        </Form.Group>

        {loading ?
          <div className="text-center">
            <Spinner animation="border" variant="success" />
          </div>
          :
          <Button variant="primary" type="submit" className='margin--auto display--block' style={{ marginBottom: "30px" }}>
            Alterar
          </Button>
        }

        <span>
          <b>A senha deve conter:</b><br />- pelo menos, 6 caracteres e, no máximo, 99 caracteres.<br />- 1 caractere especial dos seguintes: ^ $ * . [ ] { } ( ) ? " ! @ # % & / \ <br />- Letra maiúscula<br />- Letra minúscula
        </span>
      </Form>
    </div>
  );
};

export default ChangePassword;


